import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Link from '../utils/link'
//import Slider from 'react-slick'

import Arrow from '../assets/images/arrow-right.svg'

import SEO from "../components/seo"

// function PrevArrow(props) {
//   let { onClick, style, className } = props
//   let attr = { onClick, style, className }
//   return (
//     <span
//       {...attr}
//     >
//       <img src={Arrow} alt='Prev' />
//     </span>
//   )
// }

// function NextArrow(props) {
//   let { onClick, style, className } = props
//   let attr = { onClick, style, className }
//   return (
//     <span
//       {...attr}
//     >
//       <img src={Arrow} alt='Next' />
//     </span>
//   )
// }

class Project extends Component {

  render() {
    const project = this.props.data.wpPost

    // const settings = {
    //   infinite: true,
    //   speed: 600,
    //   fade: true,
    //   autoplay: true,
    //   autoplaySpeed: 5000,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   dots: false,
    //   arrows: true,
    //   cssEase: 'ease',
    //   nextArrow: <NextArrow />,
    //   prevArrow: <PrevArrow />,
    //   pauseOnHover: false,
    //   focusOnSelect: false,
    // }

    return (
      <>
        <SEO title={`${project.title} - Emily Gillis`} bodyClass='single-project' description={project.excerpt} />
        <section className='page'>
          <div className='page__inner'>
            <div className='single-project__header'>
              <Link className='back' to={'/projects'}><img src={Arrow} alt='Back to Projects' /></Link>
              <h1>{project.title}</h1>
              { project.content && <div className='single-project__content' dangerouslySetInnerHTML={{ __html: project.content }} /> }
            </div>
            { project.acf.layout === 'grid' &&
              <div className='projects__items'>
                { project.acf.gallery.map((el, i) => {
                  return (
                    <div className='projects__item' key={i}>
                      <img src={el.localFile?.childImageSharp?.original.src} alt={project.title} />
                    </div>
                  )
                })}
              </div>
            }
            { project.acf.layout === 'slider' &&
              <div className='projects__slider'>
                { project.acf.gallery.map((el, i) => {
                  return (
                    <div className='projects__slider-item' key={i}>
                      <img src={el.localFile?.childImageSharp?.original.src} alt={project.title} />
                    </div>
                  )
                })}
              </div>
            }
            <div className='single-project__footer'>
              <Link className='back' to={'/projects'}><img src={Arrow} alt='Back to Projects' /> Back to Projects</Link>
            </div>
          </div>
        </section>
      </>
    )
  }

}

export default Project

export const projectQuery = graphql`
  query Project($id: String!) {
    wpPost(id: { eq: $id }) {
      id
      title
      slug
      content
      excerpt
      acf {
        layout
        gallery {
          localFile {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
      }
    }
  }
`